import { render } from "./reservationJsonModal.vue?vue&type=template&id=ce52a6a4&scoped=true"
import script from "./reservationJsonModal.vue?vue&type=script&lang=js"
export * from "./reservationJsonModal.vue?vue&type=script&lang=js"

import "./reservationJsonModal.vue?vue&type=style&index=0&id=ce52a6a4&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce52a6a4"]])

export default __exports__